import React from 'react'
import Header from '../landing/Header/Header'

const KycRequired = () => {
    return (
        <>
            <Header />
            <section className="wallet-not-found boxkycrequired">
                <div className="custom-container">
                    <div className="parent">
                        <h5>KYC Required</h5>
                        <p>
                            Before you can claim your LEIA tokens and NFTs, you must complete the KYC (Know Your Customer) verification process. Please follow the external link to complete this step.
                            <br /><br />
                            If you have already submitted your KYC details, thank you for doing so. Our team is currently reviewing your information. Please check back later to see if your verification has been approved and to proceed with claiming your tokens.

                        </p>
                        <a href="#">Start KYC <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                            <path d="M9.83333 2V3.33333H12.2267L5.67333 9.88667L6.61333 10.8267L13.1667 4.27333V6.66667H14.5V2M13.1667 12.6667H3.83333V3.33333H8.5V2H3.83333C3.47971 2 3.14057 2.14048 2.89052 2.39052C2.64048 2.64057 2.5 2.97971 2.5 3.33333V12.6667C2.5 13.0203 2.64048 13.3594 2.89052 13.6095C3.14057 13.8595 3.47971 14 3.83333 14H13.1667C13.5203 14 13.8594 13.8595 14.1095 13.6095C14.3595 13.3594 14.5 13.0203 14.5 12.6667V8H13.1667V12.6667Z" fill="white" />
                        </svg></a>
                    </div>
                </div>
            </section>

        </>
    )
}

export default KycRequired
